import { topicTags } from '@/pages/home/data';

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-800 hover:bg-primary-200',
  accent: 'bg-accent-100 text-accent-900 hover:bg-accent-200',
  secondary: 'bg-secondary-100 text-secondary-800 hover:bg-secondary-200',
};

const sizeMap: Record<string, string> = {
  lg: 'text-base md:text-lg px-5 py-2.5 font-bold',
  md: 'text-sm px-4 py-2 font-medium',
  sm: 'text-xs px-3.5 py-1.5',
};

export default function TopicWall() {
  return (
    <section id="topics" className="scroll-mt-20 bg-background-100">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="text-xs font-medium tracking-[0.24em] text-secondary-700">TOPIC WALL</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              大家都在关注的话题
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md">
            点击任意话题，即可快速定位到对应的下载与安装说明。
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          {topicTags.map((tag) => (
            <a
              key={tag.text}
              href="#download"
              className={`inline-flex items-center gap-1.5 rounded-full transition-colors cursor-pointer whitespace-nowrap ${toneMap[tag.tone]} ${sizeMap[tag.size]}`}
            >
              <span className="text-current opacity-70">#</span>
              {tag.text}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}